var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25.5"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 224362"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Stroke 1",
  d: "M21.205 9.465s-.7 8.738-1.113 12.418a2.9 2.9 0 0 1-3.059 2.82 260.54 260.54 0 0 1-10.157-.006 2.872 2.872 0 0 1-2.97-2.8C3.494 18.179 2.794 9.465 2.794 9.465"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Stroke 3",
  d: "M22.999 5.276h-22"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Stroke 5",
  d: "M18.76 5.277a2.138 2.138 0 0 1-2.1-1.718l-.315-1.578a1.66 1.66 0 0 0-1.6-1.231H9.253a1.66 1.66 0 0 0-1.6 1.231l-.315 1.578a2.138 2.138 0 0 1-2.1 1.718"
}))));
export default SvgTrash;